import { SegmentationIds } from 'constants/segmentation';

export default {
  'landingpage:foodlines-presenter:usps:no-animal-testing': 'Without{br}animal testing',
  'landingpage:foodlines-presenter:usps:best-quality': 'Best{br}raw material quality',
  'landingpage:foodlines-presenter:usps:high-acceptance': 'particularly high{br}acceptance',
  'landingpage:foodlines-presenter:usps:no-grain': 'without{br}grain &amp; gluten',
  'landingpage:general:control-variant:discover': 'I want to improve the nutrition for',
  'landingpage:general:control-variant:for-dogs': '<span>m</span>y dog',
  'landingpage:general:control-variant:for-cats': '<span>m</span>y cat',

  'landingpage:value-proposition:header': 'Fresh & delicious, straight into the bowl.',
  'landingpage:value-proposition:header-2': 'Fresh ingredients. Best taste. Individual selection.',
  'landingpage:value-proposition:sub-header': 'With <strong>30-Day Taste Guarantee </strong>',
  'landingpage:value-proposition:button': 'SAVE 15% NOW',
  'landingpage:value-proposition:success':
    'Your new customer code will be applied automatically at checkout',

  'landingpage:category-slider:title-NC': 'Browse yourself',
  'landingpage:category-slider:title-EC': 'Our food categories',

  'landingpage:fube-blutte-point-1-dog': 'Answer 10 questions about your dog',
  'landingpage:fube-blutte-point-1-cat': 'Answer 10 questions about your cat',
  'landingpage:fube-blutte-point-2': 'We find the perfect food for your furry friend',

  'landingpage:collection-slider:title': ' We are problem solvers',

  'ai-weight-analyzer:entry:label': 'Weight management',
  'ai-weight-analyzer:entry:title': 'Too thin, too heavy, or just right?',
  'ai-weight-analyzer:entry:description:dog':
    'Upload up to 3 photos and find out where your dog sits on the body condition scale.',
  'ai-weight-analyzer:entry:description:cat':
    'Upload up to 3 photos and find out where your cat sits on the body condition scale.',
  'ai-weight-analyzer:entry:cta:dog': 'Analyze weight',
  'ai-weight-analyzer:entry:cta:cat': 'Check weight',
  'ai-weight-analyzer:pet-label:dog': 'your dog',
  'ai-weight-analyzer:pet-label:cat': 'your cat',
  'ai-weight-analyzer:entry:cdp-tile:title:with-name':
    "Is {petName}'s weight okay? Check in 30 seconds.",
  'ai-weight-analyzer:entry:cdp-tile:title': "Is {petLabel}'s weight okay? Check in 30 seconds.",
  'ai-weight-analyzer:entry:cdp-tile:cta': 'Check now',
  'ai-weight-analyzer:entry:pet-profile:title:with-name':
    "Is {petName}'s weight right? Check it with a photo.",
  'ai-weight-analyzer:entry:pet-profile:title':
    "Is {petLabel}'s weight right? Check it with a photo.",
  'ai-weight-analyzer:entry:pet-profile:cta': 'Check now',
  'ai-weight-analyzer:overlay:close': 'Close',
  'ai-weight-analyzer:overlay:title': 'AI Weight Analyzer',
  'landingpage:segmentation-pulldown:sub-title': 'How can we help?',
  'landingpage:segmentation-pulldown:intolerance': 'My dog has <b>intolerances</b>',
  'landingpage:segmentation-pulldown:pickyeater': 'My dog is <b>very picky</b>',
  'landingpage:segmentation-pulldown:digestion': 'My dog has <b>digestive problems</b>',
  'landingpage:segmentation-pulldown:skin-fur': 'My dog has <b>skin & coat problems</b>',
  'landingpage:segmentation-pulldown:welpe': 'My dog is <b>a puppy (0-1 years)</b>',
  'landingpage:segmentation-pulldown:senior': 'My dog is <b>a senior (8+ years)</b>',
  'landingpage:segmentation-pulldown:overweight': 'My dog is <b>overweight</b>',
  'landingpage:segmentation-pulldown:foodaid': 'Not sure? Get advice now',
  'landingpage:segmentation-pulldown:no-help-needed': '... has no special needs',
  'landingpage:segmentation-pulldown:pickyeatercat': 'My cat is <b>picky</b>',
  'landingpage:segmentation-pulldown:digestioncat': 'My cat has <b>digestive problems</b>',
  'landingpage:segmentation-pulldown:overweightcat': 'My cat is <b>overweight</b>',
  'landingpage:segmentation-pulldown:sterilized': 'My cat is <b>sterilized</b>',
  'landingpage:segmentation-pulldown:outdoor': 'My cat is an <b>outdoor cat</b>',
  'landingpage:segmentation-pulldown:kitten': 'My cat is a <b>kitten (0-1 years)</b>',
  'landingpage:segmentation-pulldown:seniorcat': 'My cat is a <b>senior (10+ years)</b>',
  [`landingpage:segmentation-pulldown:${SegmentationIds.IntoleranceCat}`]:
    'My cat has <b>intolerances</b>',
  [`landingpage:segmentation-pulldown:${SegmentationIds.SkinFurCat}`]:
    'My cat has <b>fur or skin problems</b>',

  'landingpage:slider-selection-pickyeater': 'Picky',
  'landingpage:slider-selection-digestion': 'Digestive problems',
  'landingpage:slider-selection-intolerance': 'Intolerances',
  'landingpage:slider-selection-prevention': 'Health prevention',
  'landingpage:slider-selection-skin-fur': 'Coat & skin problems',
  'landingpage:slider-selection-overweight': 'Overweight',
  'landingpage:slider-selection-junior': 'Puppy',
  'landingpage:slider-selection-kitten': 'Kitten',
  'landingpage:slider-selection-senior': 'Senior',

  'landingpage:nutrition-needs-guidance:last-slide-redirect': 'More suitable products',
  'landingpage:influencer-slider:title': "#{name}'s favorites",
  'landingpage:influencer-slider:cta-button': 'More products',

  'landingpage:special-and-limited-editions-slider:title': 'Our highlights',
  'landingpage:last-slider-CTA-Snacks': 'Discover our snacks',
  'landingpage:last-slider-CTA-Zubehör': 'Discover our accessories',
  'landingpage:last-slider-CTA-Gesundheit': 'Health for dogs',
  'landingpage:last-slider-CTA-Pflege': 'Discover our care products',
  'landingpage:last-slider-CTA-default': 'Discover our other products',

  [`landingpage:breed-slider:breed:${SegmentationIds.Bulldog}`]: 'Bulldog',
  [`landingpage:breed-slider:breed:${SegmentationIds.Chihuahua}`]: 'Chihuahua',
  [`landingpage:breed-slider:breed:${SegmentationIds.Dachshund}`]: 'Dachshund',
  [`landingpage:breed-slider:breed:${SegmentationIds.Havanese}`]: 'Maltese',
  [`landingpage:breed-slider:breed:${SegmentationIds.Poodle}`]: 'Poodle',
  [`landingpage:breed-slider:breed:${SegmentationIds.Retriever}`]: 'Retriever',
  [`landingpage:breed-slider:breed:${SegmentationIds.ShepherdDog}`]: 'Shepherd dog',
  [`landingpage:breed-slider:breed:${SegmentationIds.Spitz}`]: 'Spitz',
  [`landingpage:breed-slider:breed:${SegmentationIds.Terrier}`]: 'Terrier',
  [`landingpage:breed-slider:breed:${SegmentationIds.Herdingdog}`]: 'Herding dog',
  [`landingpage:breed-slider:breed:${SegmentationIds.MixedSmall}`]: 'Mixed breed - small',
  [`landingpage:breed-slider:breed:${SegmentationIds.MixedLarge}`]: 'Mixed breed - large',

  'landingpage:problem-solver:description':
    'Finding the right food can be quite frustrating. After all, every dog is unique - with individual problems and needs! We have set ourselves the goal of developing the right recipe for every need.',
  'landingpage:problem-solver-cat:description':
    'Finding the right food can be quite frustrating. After all, every cat is unique - with individual problems and needs! We have set ourselves the goal of developing the right recipe for every need.',

  'landingpage:nutrition-usps:grains': 'Without grain{br}& sugar',
  'landingpage:nutrition-usps:meat': 'Fresh{br}meat',
  'landingpage:nutrition-usps:additives': 'Free of flavor,{br}color & fillers',
  'landingpage:nutrition-usps:texture': 'Appealing{br}consistency & smell',
  'landingpage:nutrition-usps:fruits': 'Fresh fruit{br}& vegetables',
  'landingpage:nutrition-usps:gentle': 'Gently{br}processed',

  'landingpage:problem-solver:sub-headline':
    'Naturally under the highest Pets Deli quality standards:',
  'landingpage:problem-solver:cta': 'Learn more about Pets Deli',

  'landingpage:greeting': 'NICE To See You Again!',

  'landingpage:ad-tile:cta-button:pickyeater': 'Food for picky eaters',
  'landingpage:ad-tile:cta-button:intolerance': 'Food for dogs with allergies',
  'landingpage:ad-tile:cta-button:skin-fur': 'Food to strengthen skin & coat',
  'landingpage:ad-tile:cta-button:digestion': 'Food for dogs with sensitive digestion',
  'landingpage:ad-tile:cta-button:overweight': 'Food for a slim figure',
  'landingpage:ad-tile:cta-button:senior': 'Food for older dogs',
  'landingpage:ad-tile:cta-button:welpe': 'Food for puppies',
  'landingpage:ad-tile:cta-button:bulldog': 'Food for Bulldogs',
  'landingpage:ad-tile:cta-button:chihuahua': 'Food for Chihuahuas',
  'landingpage:ad-tile:cta-button:dachshund': 'Food for Dachshunds',
  'landingpage:ad-tile:cta-button:havanese': 'Food for Maltese',
  'landingpage:ad-tile:cta-button:herdingdog': 'Food for Herding Dogs',
  'landingpage:ad-tile:cta-button:poodle': 'Food for Poodles',
  'landingpage:ad-tile:cta-button:retriever': 'Food for Retrievers',
  'landingpage:ad-tile:cta-button:shepherd-dog': 'Food for Shepherd Dogs',
  'landingpage:ad-tile:cta-button:spitz': 'Food for Spitz',
  'landingpage:ad-tile:cta-button:terrier': 'Food for Terriers',
  'landingpage:ad-tile:cta-button:pickyeatercat': 'Food for picky eaters',
  'landingpage:ad-tile:cta-button:seniorcat': 'Food for older cats',
  'landingpage:ad-tile:cta-button:kitten': 'Food for kittens',
  'landingpage:ad-tile:cta-button:digestioncat': 'Food for cats with sensitive digestion',
  'landingpage:ad-tile:cta-button:overweightcat': 'Food for a slim figure',
  'landingpage:ad-tile:cta-button:outdoor': 'Food for outdoor cats',
  'landingpage:ad-tile:cta-button:sterilized': 'Food for sterilized cats',

  'landingpage:ad-tile:cta-button:set-new-option': 'Or adjust your need',

  'landingpage:bestseller-slider:title:dogs': 'Popular with Doggos',
  'landingpage:bestseller-slider:title:cats': 'Popular with Kitties',

  'landingpage:bestseller-slider:title-profile-no-name:dogs': 'Recommended for your dog',
  'landingpage:bestseller-slider:title-profile-no-name:cats': 'Recommended for your cat',

  'landingpage:bestseller-slider:title-profile-with-name': 'Perfect for {petName}',

  'landingpage:home:home:title': 'Healthy starts \nin the bowl!',
  'landingpage:home:home:sub-title': 'Who are you looking for the <span>perfect food for?</span>',

  'landingpage:home:sub-headline': 'We find the perfect food for you!',
  'landingpage:home:cta-button': 'Choose need...',
  'landingpage:home:breed-selector:headline': 'Or choose a breed',

  'landingpage:home:global-rating-values': '{rating} ({count} product reviews)',

  'landingpage:home:slider:headline': 'Individual needs. Individual formulations.',

  'landingpage:home:fube-entry:headline': 'For the more difficult cases Digital food advisor',
  'landingpage:home:fube-entry:image-alt': 'Exactly for me',
  'landingpage:home:fube-entry:usp-1': 'Has already helped <span>12,567</span> customers find food',
  'landingpage:home:fube-entry:usp-2:dog':
    'Answer 7 questions. We tell you what your <span>Doggo</span> needs.',
  'landingpage:home:fube-entry:usp-2:cat':
    'Answer 7 questions. We tell you what <span>your kitty</span> needs',

  'landingpage:home:dog-cat:slider:headline':
    'Trial packs with introductory discount & free food guide',
  'landingpage:standalone-cdp:headline': 'Discover our variety',
  'landingpage:standalone-cdp:ec-dog:sub-headline': 'Just try healthy',
  'landingpage:standalone-cdp:nc-cat:sub-headline': 'Just try healthy',
  'landingpage:standalone-cdp:nc-dog:sub-headline': 'Just try healthy',
  'landingpage:standalone-cdp:home:sub-headline': 'Individual needs. Individual formulations.',

  'landingpage:need-capture:which-need-most-applied': 'Which need applies <b>MOST</b>?',
  'landingpage:need-capture:which-need-most-applied-dog':
    'Tell us which need applies <b>MOST</b> to your dog <b>OR</b> choose a breed:{br} <a>When do I prefer to choose a need? When do I prefer to choose a breed?</a>',
  'landingpage:need-capture:which-need-most-applied-cat':
    'Tell us which need applies<b> MOST </b> to your cat',
  'landingpage:need-capture:title': 'Favorite food.{br} just for you!',
  'landingpage:need-capture:sub-title:dog':
    "Healthy starts in the bowl – and we're here to help you find the perfect food for your doggo!",
  'landingpage:need-capture:sub-title:cat':
    "Healthy starts in the bowl – and we're here to help you find the perfect food for your kitty(s)!",
  'landingpage:need-capture:date-of-birth:month:label': 'Birth month',
  'landingpage:need-capture:date-of-birth:month:placeholder': 'MM',
  'landingpage:need-capture:date-of-birth:year:label': 'Birth year',
  'landingpage:need-capture:date-of-birth:year:placeholder': 'YYYY',
  'landingpage:need-capture:date-of-birth:text:dog':
    '<row><label>My dog was born in</label>{dateOfBirth}</row>' +
    '<row><label>, is a</label>{breed}</row>' +
    '<row><label>has</label>{needs}</row>' +
    '<row><label>and prefers</label>{food}</row>',
  'landingpage:need-capture:date-of-birth:text:cat':
    '<row><label>My cat was born in</label>{dateOfBirth}</row>' +
    '<row><label>, has</label>{needs}</row>' +
    '<row><label>and eats most of all</label>{food}</row>',
  'landingpage:need-capture:age:text:dog': 'My dog is a',
  'landingpage:need-capture:age:text:cat': 'My cat is',
  'landingpage:need-capture:age:text:cat:separator': 'has',
  'landingpage:need-capture:age:text:cat:separator-2': 'and eats',
  'landingpage:need-capture:age:text:cat:separator-3': 'most of all',
  'landingpage:need-capture:age:text:cat:separator-4': 'and',
  'landingpage:need-capture:age:text:cat:separator-5': 'prefers most',
  'landingpage:need-capture:age:placeholder': 'Age',
  'landingpage:need-capture:breed:placeholder': 'Breed',
  'landingpage:need-capture:breed:text': 'and has',
  'landingpage:need-capture:breed:text:mobile': 'and has',
  'landingpage:need-capture:breed:text:desktop': 'and',
  'landingpage:need-capture:needs:placeholder': 'The following need',
  'landingpage:need-capture:needs:text:desktop': 'has',
  'landingpage:need-capture:food-type-and-taste:placeholder': 'Food type & taste',
  'landingpage:need-capture:dog-food-type:placeholder': 'Food type',
  'landingpage:need-capture:dog-food-type:text:mobile': 'and prefers',
  'landingpage:need-capture:dog-food-type:text:desktop:above': 'and',
  'landingpage:need-capture:dog-food-type:text:desktop:inline': 'prefers',

  [`landingpage:need-capture:age:${SegmentationIds.Welpe}`]: 'Junior',
  [`landingpage:need-capture:age:${SegmentationIds.DogAdult}`]: 'Adult',
  [`landingpage:need-capture:age:${SegmentationIds.DogSenior}`]: 'Senior',
  [`landingpage:need-capture:age:${SegmentationIds.Kitten}`]: 'Kitten',
  [`landingpage:need-capture:age:${SegmentationIds.CatAdult}`]: 'Adult',
  [`landingpage:need-capture:age:${SegmentationIds.CatSenior}`]: 'Senior',

  [`landingpage:need-capture:breed:${SegmentationIds.Bulldog}`]: 'Bulldog',
  [`landingpage:need-capture:breed:${SegmentationIds.Chihuahua}`]: 'Chihuahua',
  [`landingpage:need-capture:breed:${SegmentationIds.Dachshund}`]: 'Dachshund',
  [`landingpage:need-capture:breed:${SegmentationIds.Havanese}`]: 'Havanese',
  [`landingpage:need-capture:breed:${SegmentationIds.Poodle}`]: 'Poodle',
  [`landingpage:need-capture:breed:${SegmentationIds.Retriever}`]: 'Retriever',
  [`landingpage:need-capture:breed:${SegmentationIds.ShepherdDog}`]: 'Shepherd dog',
  [`landingpage:need-capture:breed:${SegmentationIds.Spitz}`]: 'Spitz',
  [`landingpage:need-capture:breed:${SegmentationIds.Terrier}`]: 'Terrier',
  [`landingpage:need-capture:breed:${SegmentationIds.Herdingdog}`]: 'Herding dog',
  [`landingpage:need-capture:breed:${SegmentationIds.MixedSmall}`]: 'Mixed breed (small)',
  [`landingpage:need-capture:breed:${SegmentationIds.MixedLarge}`]: 'Mixed breed (large)',

  'landingpage:need-capture:selector': 'Please choose up to 2 special needs:',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.PickyEater}`]: 'Picky Eater',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.Digestion}`]:
    'Digestive problems',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.SkinFur}`]:
    'Skin & coat problems',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.Intolerance}`]: 'Intolerances',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.Overweight}`]: 'Overweight',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.Prevention}`]:
    'Health prevention',
  [`landingpage:need-capture:need:selector:cta:confirm`]: 'Confirm selection',

  [`landingpage:need-capture:need:option:${SegmentationIds.PickyEater}`]: 'Picky eating behavior',
  [`landingpage:need-capture:need:option:${SegmentationIds.Digestion}`]: 'Digestive problems',
  [`landingpage:need-capture:need:option:${SegmentationIds.SkinFur}`]: 'Skin & coat problems',
  [`landingpage:need-capture:need:option:${SegmentationIds.Intolerance}`]: 'Intolerances',
  [`landingpage:need-capture:need:option:${SegmentationIds.Overweight}`]: 'Overweight',
  [`landingpage:need-capture:need:option:${SegmentationIds.Prevention}`]: 'Health prevention',
  [`landingpage:need-capture:need:option:${SegmentationIds.CatPickyEater}`]:
    'Picky eating behavior',
  [`landingpage:need-capture:need:option:${SegmentationIds.CatDigestion}`]: 'Digestive problems',
  [`landingpage:need-capture:need:option:${SegmentationIds.CatOverweight}`]: 'Overweight',
  [`landingpage:need-capture:need:option:${SegmentationIds.IntoleranceCat}`]: 'Intolerances',
  [`landingpage:need-capture:need:option:${SegmentationIds.SkinFurCat}`]: 'Skin & coat problems',
  [`landingpage:need-capture:need:option:${SegmentationIds.HairballHelp}`]: 'hairball help',
  [`landingpage:need-capture:need:option:${SegmentationIds.ImmuneSystem}`]:
    'a weakened immune system',
  'landingpage:need-capture:heroImage:description': 'Image of pet on hero section',

  'landingpage:need-capture:products-list:title': 'These bestsellers are made for you:',
  'landingpage:need-capture:products-list:default-cat-title': 'Our bestsellers for cats',
  'landingpage:need-capture:products-list:cta': 'Show all products →',
  'empty-product-list:text:dog':
    'Tell us more about your dog above and we will show you matching recommendations here.',
  'empty-product-list:text:cat':
    'Tell us more about your cat above and we will show you matching recommendations here.',

  'landingpage:about-us-modal:headline':
    'Hi! We are Pets Deli and we make food that can really do something.',
  'landingpage:about-us-modal:section:1':
    '<b>What that means: </b> We know that food must be individual. Because every pet has different needs. Whether puppy, senior, illnesses, allergies or picky eater - off-the-shelf food is rarely suitable. Because conventional food usually places little value on high-quality ingredients or composition. It often consists of a very large proportion of grain or other cheap fillers, a very small proportion of meat as well as flavor enhancers, sugar and indigestible waste from the food industry such as claws, feathers or hooves. This not only sounds disgusting, but is also nutritionally not the best you can offer your pet.',
  'landingpage:about-us-modal:section:2':
    '<b>We do it differently: </b> With our products, we specifically address the individual nutritional needs of your pet. We offer tailor-made menus that, thanks to their sophisticated recipes, help solve a large part of all food problems. To achieve this, we invest a lot of time in product development: Our veterinarians work on the basis of the latest nutritional science and always ensure a species-appropriate, high-quality and taste-intensive composition.',
  'landingpage:about-us-modal:section:3:dogs':
    '<b>Our promise: </b> We place particular emphasis on the quality of our raw materials, gentle processing and the composition of our products. Of course, we also incorporate customer feedback into our product developments and constantly expand our range. What comes out of it? A wide range of products for the most diverse needs: Delicious wet food, wholesome dry food, fresh BARF, meatless alternatives as well as lots of functional, healthy and tasty snacks. Fresh ingredients such as real meat, vitamin-rich fruit & vegetables as well as valuable oils and minerals ensure the first-class Pets Deli taste and support not only the health but also the quality of life of your doggo.',
  'landingpage:about-us-modal:section:3:cats':
    '<b>Our promise: </b> We place particular emphasis on the quality of our raw materials, gentle processing and the composition of our products. Of course, we also incorporate customer feedback into our product developments and constantly expand our range. What comes out of it? A wide range of products for the most diverse needs: Delicious wet food, wholesome dry food as well as lots of functional, healthy and tasty snacks. Fresh ingredients such as real meat, vitamin-rich fruit & vegetables as well as valuable oils and minerals ensure the first-class Pets Deli taste and support not only the health but also the quality of life of your kitty.',

  'landingpage:home:fte-segmentation:dog:info-text':
    'To find the perfect food, tell us which need {br} best applies to your dog or choose the appropriate breed:',
  'landingpage:home:fte-segmentation:cat:info-text':
    'Tell us which need applies<b> MOST </b> to your cat',
  'landingpage:home:fte-segmentation:dog:info-text-2':
    'Tell us which need applies <b>MOST</b> to your dog <b>OR</b> choose a breed:',
  'landingpage:home:fte-segmentation:dog:info-text-3':
    'When do I prefer to choose a need? When do I prefer to choose a breed?',
  'landingpage:home:fte-segmentation:cat:info-text-2':
    'Tell us which need applies <b>MOST</b> to your cat',
  'landingpage:home:fte-segmentation:cat:info-text-3':
    'When do I prefer to choose a need? When do I prefer to choose a breed?',

  // Picky Cats engagement test — EN parity for the picky-cats:* ids served by the app IntlProvider.
  'picky-cats:question:bowl-shape:prompt': "What shape is your cat's bowl?",
  'picky-cats:question:bowl-shape:option:deep-narrow': 'Deep or narrow',
  'picky-cats:question:bowl-shape:option:wide-shallow': 'Wide and shallow',
  'picky-cats:question:bowl-shape:option:not-sure': 'Not sure',
  'picky-cats:question:bowl-location:prompt': "Where's the food bowl?",
  'picky-cats:question:bowl-location:option:near-litter': 'Near litter box or trash',
  'picky-cats:question:bowl-location:option:busy-spot': 'In a busy spot',
  'picky-cats:question:bowl-location:option:quiet-spot': 'Quiet and calm spot',
  'picky-cats:question:feeding-frequency:prompt': 'How often does your cat eat?',
  'picky-cats:question:feeding-frequency:option:once': 'Once a day',
  'picky-cats:question:feeding-frequency:option:twice-plus': 'Two or more set meals',
  'picky-cats:question:feeding-frequency:option:free-feed': 'Always available (free feeding)',
  'picky-cats:question:feed-temperature:prompt': 'How do you serve the food?',
  'picky-cats:question:feed-temperature:option:cold': 'Straight from the fridge',
  'picky-cats:question:feed-temperature:option:room-temp': 'At room temperature',
  'picky-cats:question:feed-temperature:option:warmed': 'Slightly warmed up',
  'picky-cats:question:multi-cat:prompt': 'Are there other cats in the household?',
  'picky-cats:question:multi-cat:option:solo': 'Just this one',
  'picky-cats:question:multi-cat:option:shared-bowl': 'Yes, sharing the bowl',
  'picky-cats:question:multi-cat:option:separate-bowls': 'Yes, with separate bowls',
  'picky-cats:cta:next': 'Continue',
  'picky-cats:cta:see-all': 'See all',
  'picky-cats:cta:browse-collection': 'See picky-eater favorites',
  'picky-cats:a11y:back': 'Back',
  'picky-cats:entry:engagement:eyebrow': 'Cat science',
  'picky-cats:entry:engagement:headline': "Maybe your cat isn't picky after all",
  'picky-cats:entry:engagement:subtitle':
    "It's often about how we feed, not what. Find out what's really behind it.",
  'picky-cats:entry:engagement:cta': 'Find out now',
  'picky-cats:entry:engagement:v2:headline': 'The bowl shape matters',
  'picky-cats:entry:engagement:v2:subtitle':
    'And a few other small tricks most owners never hear about.',
  'picky-cats:entry:engagement:v2:cta': 'Check your setup',
  'picky-cats:floating:label': 'Picky cat?',
  'picky-cats:tip:bowl:text': 'Swap to a wide, shallow bowl so whiskers never touch the sides.',
  'picky-cats:tip:location:text': 'Move the bowl away from the litter box and busy walkways.',
  'picky-cats:tip:temperature:text': 'Serve food at room temperature to bring out the aroma.',
  'picky-cats:result:recommendation-heading': 'Recommendation for you',
  'picky-cats:result:tips-title': 'This could help your cat',
  'picky-cats:result:tips-subtitle': 'Small tweaks with a big impact — plus matching products.',
};
